import React from 'react';
import type { UserProfile } from '../../lib/supabase';
import { getUserColorFromId, getUserInitial } from '../../utils/userColor';

interface AssignedUserBadgeProps {
  assignedUser?: UserProfile | null;
  size?: 'small' | 'medium';
}

export const AssignedUserBadge: React.FC<AssignedUserBadgeProps> = ({
  assignedUser,
  size = 'small',
}) => {
  if (!assignedUser) {
    return null;
  }

  const sizeClasses = size === 'small'
    ? 'h-5 w-5 text-[9px]'
    : 'h-6 w-6 text-xs';

  const textSizeClass = size === 'small' ? 'text-[9px]' : 'text-sm';
  const colorClasses = getUserColorFromId(assignedUser.id);
  const initial = getUserInitial(assignedUser.nickname, assignedUser.email);

  return (
    <div
      className={`${sizeClasses} rounded-full bg-gradient-to-br ${colorClasses} flex items-center justify-center flex-shrink-0`}
      title={assignedUser.nickname || assignedUser.email || 'Unknown'}
    >
      {assignedUser.avatar_url ? (
        <img
          src={assignedUser.avatar_url}
          alt={assignedUser.nickname || 'User'}
          className="w-full h-full rounded-full object-cover"
        />
      ) : (
        <span className={`text-white font-semibold ${textSizeClass}`}>
          {initial}
        </span>
      )}
    </div>
  );
};
